import React, { PureComponent } from 'react'
import Logo from 'app/Components/LogoSmall'
import Survey from 'app/Components/Survey'
import Submit from 'app/Components/Survey/Submit'

export default class FormPage extends PureComponent {
  render() {
    return (
      <div>
        <Survey>
          <Logo />
          <Submit>
            <h1>Thank You</h1>
            <p>
              Thank you for your interest in joining our network. We look
              forward to getting to know more about you and will be in touch
              soon.
            </p>
          </Submit>
        </Survey>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./thank-you/index.js
 **/